"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));
var _smartyStreetsService = _interopRequireDefault(require("./smarty-streets-service"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DEFAULT_SUGGESTIONS = 5;
var MAX_SUGGESTIONS = 10;
var TIMEOUT_DELAY = 500; // 0.5 sec
var PFAddressService = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PFAddressService, _Component);
  var _super = _createSuper(PFAddressService);
  function PFAddressService(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PFAddressService);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSuggestionValue", function (suggestion) {
      return suggestion.street;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSuggestion", function (suggestion) {
      return /*#__PURE__*/_react.default.createElement("span", null, suggestion.hint);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSuggestionsSuccess", function (response) {
      var responseSuggestions = response.data.suggestions;
      if (responseSuggestions) {
        var suggestions = responseSuggestions.map(function (suggestion) {
          return {
            street: suggestion.street_line,
            city: suggestion.city,
            state: suggestion.state,
            zipcode: suggestion.zipcode,
            hint: "".concat(suggestion.street_line, ", ").concat(suggestion.city, ", ").concat(suggestion.state)
          };
        });
        _this.setState({
          suggestions: suggestions
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSuggestionsError", function (error) {
      var onErrorCallback = _this.defaultProps.onErrorCallback;
      if (onErrorCallback) {
        onErrorCallback(error.message);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSuggestions", function () {
      var _this$smartyStreetsSe = _this.smartyStreetsService,
        authId = _this$smartyStreetsSe.authId,
        suggestionURL = _this$smartyStreetsSe.suggestionURL;
      if (_this.smartyStreetsRequestObj && authId && suggestionURL) {
        _this.smartyStreetsService.getSuggestions(_this.smartyStreetsRequestObj).then(_this.getSuggestionsSuccess).catch(_this.getSuggestionsError);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "debounce", function (func, delay) {
      return setTimeout(function () {
        func.apply();
      }, delay);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSuggestionsFetchRequested", function (_ref) {
      var value = _ref.value;
      // if input doesn't start with a number or SmartyStreet service is not available
      var startWithNumber = /^[0-9].*$/;
      if (!startWithNumber.test(value) || !_this.smartyStreetsService) return;
      var timeoutdelay = _this.defaultProps.timeoutdelay;
      _this.smartyStreetsRequestObj.value = value;
      clearTimeout(_this.timeoutID);
      _this.timeoutID = _this.debounce(_this.getSuggestions, timeoutdelay);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSuggestionsClearRequested", function () {
      _this.setState({
        suggestions: []
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSuggestionSelected", function (e, selected) {
      var onSuggestionSelected = _this.props.onSuggestionSelected;
      var suggestionSelected = {};
      suggestionSelected.street = selected.suggestion.street;
      suggestionSelected.city = selected.suggestion.city;
      suggestionSelected.state = selected.suggestion.state;
      suggestionSelected.zip = selected.suggestion.zipcode;
      _this.setState({
        suggestionSelected: suggestionSelected
      });
      if (onSuggestionSelected) {
        onSuggestionSelected(_this.defaultProps.id, suggestionSelected);
      }
      e.preventDefault();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnBlur", function (event, _ref2) {
      var highlightedSuggestion = _ref2.highlightedSuggestion;
      var onBlurCallback = _this.props.onBlurCallback;
      var suggestion = {};
      if (onBlurCallback) {
        if (highlightedSuggestion) {
          suggestion = highlightedSuggestion;
        } else if (_this.state.suggestionSelected) {
          suggestion = _this.state.suggestionSelected;
        }
        event.target['data-address-suggestion'] = JSON.stringify(suggestion);
        onBlurCallback(event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnFocus", function (event) {
      var onFocusCallback = _this.props.onFocusCallback;
      if (onFocusCallback) {
        onFocusCallback(event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleOnChange", function (event, _ref3) {
      var newValue = _ref3.newValue,
        method = _ref3.method;
      var onChangeCallback = _this.defaultProps.onChangeCallback;
      if (event.target.tagName !== 'INPUT') {
        var inputElement = _this.container.current.input;
        event.target = inputElement;
      }
      _this.setState({
        value: newValue
      });
      if (onChangeCallback) {
        onChangeCallback(event);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateDefaultProps", function (defaultProps, inputprops) {
      var localProps = _objectSpread({}, defaultProps);
      for (var prop in inputprops) {
        if (inputprops.hasOwnProperty(prop)) {
          var value = inputprops[prop];
          if (prop === 'timeoutdelay' && (value > TIMEOUT_DELAY || value < 100)) {
            // time is in milliseconds
            value = TIMEOUT_DELAY;
          }
          if (prop === 'maxsuggestions' && (value > MAX_SUGGESTIONS || value < 1)) {
            value = DEFAULT_SUGGESTIONS;
          }
          localProps[prop] = value;
        }
      }
      return localProps;
    });
    _this.state = {
      value: _this.props.inputprops && _this.props.inputprops.value || '',
      suggestions: [],
      suggestionSelected: ''
    };
    _this.container = /*#__PURE__*/_react.default.createRef();
    return _this;
  }
  (0, _createClass2.default)(PFAddressService, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props$smartystr = this.props.smartystreetsconfig,
        authId = _this$props$smartystr.authId,
        suggestionURL = _this$props$smartystr.suggestionURL;
      var maxsuggestions = this.defaultProps.maxsuggestions;
      this.timeoutID;
      this.smartyStreetsRequestObj = {};
      this.smartyStreetsService = new _smartyStreetsService.default({
        authId: authId,
        suggestions: maxsuggestions,
        suggestionURL: suggestionURL
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        value = _this$state.value,
        suggestions = _this$state.suggestions;
      if (this.props.inputprops) {
        this.defaultProps = this.updateDefaultProps(this.defaultProps, this.props.inputprops);
      } else {
        this.props.inputprops = this.defaultProps;
      }
      this.defaultProps.value = value;
      this.defaultProps.onChange = this.handleOnChange;
      this.defaultProps.onBlur = this.handleOnBlur;
      this.defaultProps.onFocus = this.handleOnFocus;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactAutosuggest.default, {
        suggestions: suggestions,
        onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
        onSuggestionsClearRequested: this.onSuggestionsClearRequested,
        getSuggestionValue: this.getSuggestionValue,
        renderSuggestion: this.renderSuggestion,
        onSuggestionSelected: this.onSuggestionSelected,
        containerProps: this.props.containerProps,
        ref: this.container,
        renderInputComponent: this.props.renderInputComponent,
        renderSuggestionsContainer: this.props.renderSuggestionsContainer,
        inputProps: this.defaultProps
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.inputprops && props.inputprops.value !== state.value && props.isYTS) {
        state.value = props.inputprops.value || '';
      }
      return state;
    }
  }]);
  return PFAddressService;
}(_react.Component);
(0, _defineProperty2.default)(PFAddressService, "propTypes", {
  inputprops: _propTypes.default.object.isRequired,
  smartystreetsconfig: _propTypes.default.object.isRequired,
  geolocate: _propTypes.default.string,
  renderInputComponent: _propTypes.default.func
});
PFAddressService.propTypes = {
  containerProps: _propTypes.default.object,
  renderSuggestionsContainer: _propTypes.default.object,
  isYTS: _propTypes.default.bool,
  inputprops: _propTypes.default.object,
  smartystreetsconfig: _propTypes.default.object,
  renderInputComponent: _propTypes.default.func,
  maxsuggestions: _propTypes.default.number,
  onErrorCallback: _propTypes.default.func,
  timeoutdelay: _propTypes.default.number,
  onSuggestionSelected: _propTypes.default.func,
  onBlurCallback: _propTypes.default.func,
  onFocusCallback: _propTypes.default.func,
  onChangeCallback: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  id: _propTypes.default.string,
  value: _propTypes.default.number
};
PFAddressService.defaultProps = {
  'className': 'street-address',
  placeholder: 'Street Address',
  autoComplete: 'disabled',
  geolocate: 'true',
  geolocate_precision: 'city',
  maxsuggestions: DEFAULT_SUGGESTIONS,
  timeoutdelay: TIMEOUT_DELAY,
  smartystreetsconfig: {
    suggestionURL: 'https://us-autocomplete-pro.api.smartystreets.com/lookup',
    streetAddressURL: 'https://us-street.api.smarty.com/street-address',
    authId: '4351535203440229'
  }
};
var _default = PFAddressService;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/pf-address-service/dist/pf-address-service.scss');